import { render, staticRenderFns } from "./VehiculoCaracteristica.vue?vue&type=template&id=2919e340"
import script from "./VehiculoCaracteristica.vue?vue&type=script&lang=js"
export * from "./VehiculoCaracteristica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports